import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { Badge } from "@/shared/ui/badge";

import { lifecycleIntent } from "../lib/status";
import type { Lifecycle } from "../lib/types";

interface StatusBadgeProps {
  status: Lifecycle;
}

export function StatusBadge({ status }: StatusBadgeProps): JSX.Element {
  const { t } = useTranslation("orders");
  const intent = lifecycleIntent(status);
  return (
    <Badge
      intent={intent}
      dot
      data-testid="order-status-badge"
      data-status={status}
      data-intent={intent}
    >
      {t(`st_${status}`)}
    </Badge>
  );
}
